import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SessionData, SyncSessionService } from "src/app/core/services/sync-session.service";

export const mainLayoutResolver: ResolveFn<void> = () => inject(SyncSessionService).loadSession();
